import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\hp\\Desktop\\Namaste-Jharkhand\\src\\app\\categories-screen\\CategoriesClient.tsx");
